import { Button, chakra } from "@chakra-ui/react";

import {
  Box,
  Flex,
  Text,
  Textarea,
  HStack,
  IconButton,
} from "@chakra-ui/react";

export const ReportCardContainer = chakra(Box, {
  baseStyle: {
    bg: "white",
    borderRadius: "xl",
    m: "4px",
    p: "15px",
    shadow: "sm",
    border: "1px solid",
    borderColor: "gray.200",
    w: "full",
  },
});

export const ReportItemContainer = chakra(HStack, {
  baseStyle: {
    justifyContent: "space-between",
    alignItems: "center",
    p: 3,
    border: "1px solid",
    borderColor: "gray.100",
    borderRadius: "md",
    gap: "30px",
    minHeight: "60px", // Ensure consistent height
  },
});

export const ViewReportButton = chakra(Button, {
  baseStyle: {
    size: "sm",
    variant: "outline",
    bg: "#FFFFFF",
    color: "#40599B",
    border: "1px solid #40599B",
    fontSize: "14px",
    height: "35px",
    width: "140px",
    minWidth: "140px", // Prevent shrinking below this width
    flexShrink: 0, // Prevent the button from shrinking
  },
});
